import { MirrorStream, Stream } from '../stream'

type Element = HTMLElement | Window | Document
export class FromDomEvent<E extends Event> extends Stream<E, undefined, undefined, E> {
    protected elements: Element[]
    protected event: string

    constructor(elements: Element | Element[], event: string) {
        super()
        if (!(elements instanceof Array)) {
            elements = [elements]
        }
        this.elements = elements
        this.event = event
    }

    connect() {
        super.connect()
        for (const element of this.elements) {
            element.addEventListener(this.event, this.subscription as any)
        }
    }

    disconnect() {
        super.disconnect()
        for (const element of this.elements) {
            element.removeEventListener(this.event, this.subscription as any)
        }
    }

    protected subscription = (event: E) => this._value(event)
}

export function $fromDomEvent<K extends keyof WindowEventMap>(
    element: Window | Window[],
    type: K
): MirrorStream<WindowEventMap[K], undefined, undefined>
export function $fromDomEvent<K extends keyof DocumentEventMap>(
    element: Document | Document[],
    type: K
): MirrorStream<DocumentEventMap[K], undefined, undefined>
export function $fromDomEvent<K extends keyof HTMLElementEventMap>(
    element: HTMLElement | HTMLElement[],
    type: K
): MirrorStream<HTMLElementEventMap[K], undefined, undefined>

export function $fromDomEvent(element: Element | Element[], event: string): MirrorStream<Event, undefined, undefined> {
    return new FromDomEvent(element, event)
}
